import { PaymentsScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <PaymentsScreen />;
}
